/* =====================================
   LALO BY LEY — HOME.JS
   Homepage-specific animations
   ===================================== */

document.addEventListener('DOMContentLoaded', () => {

  gsap.registerPlugin(ScrollTrigger);

  /* ----------------------------------------
     HERO SECTION — Preloader trigger
  ---------------------------------------- */
  function animateHero() {
    const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });

    tl
      .to('.hero__title-word', {
        y: '0%',
        duration: 1.3,
        stagger: 0.1,
      }, 0)
      .fromTo('.hero__label',
        { opacity: 0, y: 8 },
        { opacity: 1, y: 0, duration: 0.9 },
        0.5
      )
      .fromTo('.hero__scroll-hint',
        { opacity: 0 },
        { opacity: 1, duration: 0.8 },
        1
      );
  }

  document.addEventListener('preloaderComplete', animateHero);

  /* ----------------------------------------
     PRODUCT SHOWCASE — Curtain image reveal
  ---------------------------------------- */
  const showcase = document.querySelector('.product-showcase');
  if (showcase) {
    const imageWrap = showcase.querySelector('.product-showcase__image-wrap');
    const img = imageWrap?.querySelector('img');
    const infoItems = showcase.querySelectorAll(
      '.product-showcase__category, .product-showcase__name, .product-showcase__tagline, ' +
      '.product-showcase__desc, .product-showcase__price, .product-showcase__size-select, .btn-expand'
    );

    if (imageWrap && img) {
      // Create curtain
      const curtain = document.createElement('div');
      curtain.style.cssText = `
        position:absolute; inset:0; z-index:5;
        background:#F5F5F1;  transform-origin:bottom;
      `;
      imageWrap.appendChild(curtain);

      ScrollTrigger.create({
        trigger: imageWrap,
        start: 'top 75%',
        onEnter: () => {
          gsap.to(curtain, {
            scaleY: 0,
            duration: 1.4,
            ease: 'power4.inOut',
          });
          gsap.fromTo(img,
            { scale: 1.12 },
            { scale: 1, duration: 1.6, ease: 'power3.out' }
          );
        },
      });
    }

    if (infoItems.length) {
      gsap.fromTo(infoItems,
        { opacity: 0, y: 30 },
        {
          opacity: 1, y: 0,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: showcase.querySelector('.product-showcase__info'),
            start: 'top 75%',
          },
        }
      );
    }
  }

  /* ----------------------------------------
     EDITORIAL GRID — Staggered reveals
  ---------------------------------------- */
  const editorialItems = document.querySelectorAll('.editorial__item');
  editorialItems.forEach((item, i) => {
    const img = item.querySelector('img');
    if (img) {
      const delay = i * 0.12;
      gsap.fromTo(item,
        { opacity: 0, y: 50 },
        {
          opacity: 1, y: 0,
          duration: 1,
          ease: 'power3.out',
          delay: delay,
          scrollTrigger: {
            trigger: item,
            start: 'top 80%',
          },
        }
      );
    }
  });

  /* ----------------------------------------
     COLLECTION CARDS — GSAP Horizontal Scroll hint
  ---------------------------------------- */
  const collectionCards = document.querySelectorAll('.collection-card');
  collectionCards.forEach((card, i) => {
    gsap.fromTo(card,
      { opacity: 0, x: 60 },
      {
        opacity: 1, x: 0,
        duration: 0.9,
        ease: 'power3.out',
        delay: i * 0.1,
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
        },
      }
    );
  });

  /* ----------------------------------------
     STATS COUNTER
  ---------------------------------------- */
  document.querySelectorAll('.stat-number[data-count]').forEach(el => {
    const target = parseFloat(el.dataset.count);
    const suffix = el.dataset.suffix || '';

    gsap.fromTo({ val: 0 },
      { val: target },
      {
        val: target,
        duration: 2,
        ease: 'power2.out',
        onUpdate: function() {
          el.textContent = Math.round(this.targets()[0].val) + suffix;
        },
        scrollTrigger: {
          trigger: el,
          start: 'top 80%',
        },
      }
    );
  });

});
